import React from 'react'
import propTypes from 'prop-types'
import { Chart } from 'chart.js';
import { Line } from 'react-chartjs-2'
import annotationPlugin from 'chartjs-plugin-annotation';

import { buildChartjsDataProp } from './data'
import { buildChartJsOptionsProp } from './options'
import { getChartHeight } from '@utils/heights'

export const LineChart = ({ labels, datasets, className, options, height, plugins }) => {
  Chart.register(annotationPlugin)

  return (
    <div className={className} style={{ height: getChartHeight(height) }}>
      <Line
        options={buildChartJsOptionsProp(options)}
        data={buildChartjsDataProp(datasets, labels)}
        plugins={plugins}
      />
    </div>
  )
}

LineChart.propTypes = {
  labels: propTypes.array.isRequired,
  datasets: propTypes.array.isRequired,
  className: propTypes.string,
  height: propTypes.string,
  options: propTypes.object,
  /** Inline chart.js plugins, scoped to this chart rather than registered globally. */
  plugins: propTypes.array
}

LineChart.defaultProps = {
  options: {},
  height: '',
  className: '',
  plugins: []
}

